import React from 'react'
import '../navbar/navbar.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Navbar } from 'react-bootstrap'
import { Link } from 'react-router-dom';

function navbar() {
    return (
        <Navbar expand="lg" className='navbar'>
            <div>
                <Link to='/' className='brand'>EzStay</Link>
            </div>

            <div className='menu d-flex flex-row'>
                <div className='mr-3'>
                    <Link to='/login' className='login'>Log In</Link>
                </div>
                <div>
                    <Link to='signup' id='sign'>Sign Up</Link>
                </div>
            </div>
        </Navbar>
    )
}

export default navbar
